import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function PageBanner({ title, subtitle, breadcrumb = [] }) {
  return (
    <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden hero-gradient">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-japo-yellow blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-white blur-3xl"></div>
      </div>
      <div className="container mx-auto px-4 lg:px-8 relative">
        <div className="max-w-3xl">
          {breadcrumb.length > 0 && (
            <div className="flex items-center gap-2 text-sm text-white/70 mb-4">
              <Link to="/" className="hover:text-japo-yellow">Beranda</Link>
              {breadcrumb.map((b, i) => (
                <React.Fragment key={i}>
                  <ChevronRight className="w-3 h-3" />
                  <span className={i === breadcrumb.length - 1 ? 'text-japo-yellow font-semibold' : ''}>{b}</span>
                </React.Fragment>
              ))}
            </div>
          )}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-4 tracking-tight leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg md:text-xl text-white/85 leading-relaxed max-w-2xl">{subtitle}</p>
          )}
        </div>
      </div>
    </section>
  );
}
